module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"search":"Пошук","likes":"Вподобайки","readers":"Читачі профілю"},"en":{"search":"Search","likes":"Likes","readers":"Profile readers"}}')
  delete Component.options._Ctor
}
